'use strict';

module.exports = function () {
    $('.flexible-content-toggle').on('click', function () {
        var $button = $(this);
        var $content = $button.siblings('.flexible-content-body');
        var isExpanded = $content.toggleClass('is-expanded').hasClass('is-expanded');

        $button.attr('aria-expanded', isExpanded);
    });

    $('.faq-content-toggle').on('click', function () {
        var $button = $(this);
        var $content = $button.siblings('.faq-accordian-container');
        var isExpanded = $content.toggleClass('is-expanded').hasClass('is-expanded');
        $button.attr('aria-expanded', isExpanded);
    });

    $('.floating-cta-container').each(function () {
        var $floatingCTA = $(this);
        var targetClass = $floatingCTA.data('target-component');

        if (!targetClass) {
            return;
        }

        if (targetClass.charAt(0) !== '.' && targetClass.charAt(0) !== '#') {
            targetClass = '.' + targetClass;
        }

        var target = document.querySelector(targetClass);

        if (!target) {
            return;
        }

        $floatingCTA.removeClass('d-none');

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    $floatingCTA.addClass('d-none');
                } else {
                    $floatingCTA.removeClass('d-none');
                }
            });
        }, {
            threshold: 0.2
        });

        observer.observe(target);
    });
};
